module.exports = __webpack_public_path__ + "static/media/Chat.842f84d5.svg";